<template>
    <div class="layout-auth">
        <header-auth
            title="Есть аккаунта?"
            href="/auth/login"
            buttonText="Войти" 
        />
        <div class="layout-auth__section">
            <div class="layout-auth__section-container">
                <div class="layout-auth__section-head">
                    <div class="layout-auth__section-head-title">Регистрация</div>
                    <div class="layout-auth__section-head-subtitle">Все поля являются обязательными для заполнения</div>
                </div>
                <div>
                    <form-registration @onClickSubmit="onClickSubmit" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HeaderAuth from '../../components/Headers/HeaderAuth';
import FormRegistration from '../../components/Forms/FormRegistration'
export default {
    name: 'ViewAuthRegistration',
    components: {
        HeaderAuth,
        FormRegistration
    },
    methods: {
        onClickSubmit() {
            alert("Скоро регистрация будет доступна");
        }
    }
}
</script>